{
  "version": 1,
  "asset_id": "6e3b5185-4bb3-4493-9049-6413842eb41d",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/6e3b5185-4bb3-4493-9049-6413842eb41d/process-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/6e3b5185-4bb3-4493-9049-6413842eb41d/process-1280.webp",
  "original_filename": "process-1280.webp",
  "size": 43316,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:38Z"
}
